import React, { useEffect, useState } from "react";
import query from "jquery";
import { Link, NavLink } from "react-router-dom";
import UserDropdown from "./UserDropdown";
import { useUser } from "../context/UserContext";
import { useLocation } from "react-router-dom";

const HeaderOne = () => {
  const [scroll, setScroll] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const location = useLocation();
  const { isAuthenticated, user } = useUser();

  // Add this separate useEffect for route changes
  useEffect(() => {
    setIsTransitioning(true);
    const timer = setTimeout(() => setIsTransitioning(false), 300);
    return () => clearTimeout(timer);
  }, [location]);

  useEffect(() => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    setCartCount(cart.length);
    setWishlistCount(wishlist.length);

    window.onscroll = () => {
      if (window.pageYOffset < 150) {
        setScroll(false);
      } else if (window.pageYOffset > 150) {
        setScroll(true);
      }
      return () => (window.onscroll = null);
    };

    const selectElement = query(".js-example-basic-single");
    if (selectElement.length) {
      selectElement.select2();
    }

    return () => {
      if (selectElement.length && selectElement.data("select2")) {
        selectElement.select2("destroy");
      }
    };
  }, []);

  // Set the default language
  const [selectedLanguage, setSelectedLanguage] = useState("Eng");
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };

  // Set the default currency
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const handleCurrencyChange = (currency) => {
    setSelectedCurrency(currency);
  };

  // Mobile menu support
  const [menuActive, setMenuActive] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handleMenuToggle = () => {
    setMenuActive(!menuActive);
  };

  // Search control support
  const [activeSearch, setActiveSearch] = useState(false);
  const handleSearchToggle = () => {
    setActiveSearch(!activeSearch);
  };

  // category control support
  const [activeCategory, setActiveCategory] = useState(false);
  const handleCategoryToggle = () => {
    setActiveCategory(!activeCategory);
  };
  const [activeIndexCat, setActiveIndexCat] = useState(null);
  const handleCatClick = (index) => {
    setActiveIndexCat(activeIndexCat === index ? null : index);
  };

  // Add global style for dropdown z-index and mobile menu
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .user-dropdown-menu {
        z-index: 9999 !important;
        position: absolute !important;
        background: white !important;
        box-shadow: 0 5px 20px rgba(0,0,0,0.15) !important;
        border-radius: 8px !important;
        min-width: 280px !important;
      }
      
      /* Mobile menu styles */
      .mobile-menu {
        z-index: 9998 !important;
      }
      
      .mobile-menu.active {
        z-index: 9998 !important;
      }
      
      .header-right {
        position: relative;
        z-index: 9997;
      }
      
      /* Ensure UserDropdown doesn't overlap mobile menu */
      .mobile-menu.active ~ .header-right .user-dropdown-menu {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
    return () => style.remove();
  }, []);

  return (
    <>
      <div className="overlay" />
      <div
        className={`side-overlay ${(menuActive || activeCategory) && "show"}`}
      />
      {/* ==================== Search Box Start Here ==================== */}
      <form action="#" className={`search-box ${activeSearch && "active"}`}>
        <button
          onClick={handleSearchToggle}
          type="button"
          className="search-box__close position-absolute inset-block-start-0 inset-inline-end-0 m-16 w-48 h-48 border border-gray-100 rounded-circle flex-center text-white hover-text-gray-800 hover-bg-white text-2xl transition-1"
        >
          <i className="ph ph-x" />
        </button>
        <div className="container">
          <div className="position-relative">
            <input
              type="text"
              className="form-control py-16 px-24 text-xl rounded-pill pe-64"
              placeholder="Search for plants, seeds, pots..."
            />
            <button
              type="submit"
              className="w-48 h-48 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
            >
              <i className="ph ph-magnifying-glass" />
            </button>
          </div>
        </div>
      </form>
      {/* ==================== Search Box End Here ==================== */}

      {/* ==================== Mobile Menu Start Here ==================== */}
      <div
        className={`mobile-menu scroll-sm d-lg-none d-block ${
          menuActive && "active"
        }`}
      >
        <button
          onClick={() => {
            handleMenuToggle();
            setActiveIndex(null);
          }}
          type="button"
          className="close-button"
        >
          <i className="ph ph-x" />{" "}
        </button>
        <div className="mobile-menu__inner">
          <Link to="/" className="mobile-menu__logo">
            <img src="assets/images/logo/logo.png" alt="Logo" />
          </Link>
          <div className="mobile-menu__menu">
            {/* Nav Menu Start - Like Desktop */}
            <ul className="nav-menu flex-column nav-menu--mobile">
              {/* Home */}
              <li className="nav-menu__item">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive
                      ? "nav-menu__link activePage d-block py-3"
                      : "nav-menu__link d-block py-3"
                  }
                  onClick={handleMenuToggle}
                >
                  Home
                </NavLink>
              </li>

              {/* Shop with submenu */}
              <li className="nav-menu__item">
                <div className="d-flex align-items-center justify-content-between">
                  <NavLink
                    to="/shop"
                    className={({ isActive }) =>
                      isActive
                        ? "nav-menu__link activePage py-3"
                        : "nav-menu__link py-3"
                    }
                    onClick={handleMenuToggle}
                  >
                    Shop
                  </NavLink>
                  <button
                    onClick={() => handleMenuClick(1)}
                    className="btn btn-link text-dark p-0"
                  >
                    <i
                      className={`ph ph-caret-${activeIndex === 1 ? "up" : "down"}`}
                    />
                  </button>
                </div>
                {activeIndex === 1 && (
                  <ul className="nav-submenu ps-4">
                    <li>
                      <Link
                        to="/shop"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        All Plants
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/product-details"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        Plant Details
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* Pages with submenu */}
              <li className="nav-menu__item">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="nav-menu__link py-3">Pages</span>
                  <button
                    onClick={() => handleMenuClick(2)}
                    className="btn btn-link text-dark p-0"
                  >
                    <i
                      className={`ph ph-caret-${activeIndex === 2 ? "up" : "down"}`}
                    />
                  </button>
                </div>
                {activeIndex === 2 && (
                  <ul className="nav-submenu ps-4">
                    <li>
                      <Link
                        to="/cart"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        Cart
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/wishlist"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        Wishlist
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/checkout"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        Checkout
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/become-seller"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        Become Seller
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/account"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        Account
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* Vendors with submenu */}
              <li className="nav-menu__item">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="nav-menu__link py-3">Vendors</span>
                  <button
                    onClick={() => handleMenuClick(3)}
                    className="btn btn-link text-dark p-0"
                  >
                    <i
                      className={`ph ph-caret-${activeIndex === 3 ? "up" : "down"}`}
                    />
                  </button>
                </div>
                {activeIndex === 3 && (
                  <ul className="nav-submenu ps-4">
                    <li>
                      <Link
                        to="/vendor"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        Vendors
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/vendor-details"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        Vendor Details
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* Blog with submenu */}
              <li className="nav-menu__item">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="nav-menu__link py-3">Blog</span>
                  <button
                    onClick={() => handleMenuClick(4)}
                    className="btn btn-link text-dark p-0"
                  >
                    <i
                      className={`ph ph-caret-${activeIndex === 4 ? "up" : "down"}`}
                    />
                  </button>
                </div>
                {activeIndex === 4 && (
                  <ul className="nav-submenu ps-4">
                    <li>
                      <Link
                        to="/blog"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        Plant Care Tips
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/blog-details"
                        className="d-block py-2"
                        onClick={handleMenuToggle}
                      >
                        Blog Details
                      </Link>
                    </li>
                  </ul>
                )}
              </li>

              {/* Contact */}
              <li className="nav-menu__item">
                <NavLink
                  to="/contact"
                  className={({ isActive }) =>
                    isActive
                      ? "nav-menu__link activePage d-block py-3"
                      : "nav-menu__link d-block py-3"
                  }
                  onClick={handleMenuToggle}
                >
                  Contact Us
                </NavLink>
              </li>

              {/* Become Seller for mobile (if not in menu) */}
              {!isAuthenticated && (
                <li className="nav-menu__item mt-3">
                  <Link
                    to="/account?redirect=become-seller"
                    className="btn btn-main w-100"
                    onClick={handleMenuToggle}
                  >
                    Become A Seller
                  </Link>
                </li>
              )}
            </ul>
            {/* Nav Menu End */}
          </div>
        </div>
      </div>
      {/* ==================== Mobile Menu End Here ==================== */}

      {/* ======================= Middle Top Start ========================= */}
      <div className="header-top bg-main-600 flex-between">
        <div className="container container-lg">
          <div className="flex-between flex-wrap gap-8">
            <ul className="flex-align flex-wrap d-none d-md-flex">
              <li className="border-right-item">
                {isAuthenticated &&
                user?.role === "seller" &&
                user?.sellerStatus === "approved" ? (
                  <Link
                    to="/seller/dashboard"
                    className="text-white text-sm hover-text-decoration-underline"
                  >
                    Seller Dashboard
                  </Link>
                ) : isAuthenticated && user?.sellerStatus === "pending" ? (
                  <span
                    className="text-white text-sm cursor-pointer hover-text-decoration-underline"
                    onClick={() =>
                      alert(
                        "Your seller application is pending approval. We'll notify you once approved.",
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    Application Pending
                  </span>
                ) : isAuthenticated && user?.sellerStatus === "rejected" ? (
                  <Link
                    to="/seller/register"
                    className="text-white text-sm hover-text-decoration-underline"
                  >
                    Apply Again
                  </Link>
                ) : (
                  <Link
                    to={
                      isAuthenticated
                        ? "/become-seller"
                        : "/account?redirect=become-seller"
                    }
                    className="text-white text-sm hover-text-decoration-underline"
                  >
                    Become A Seller
                  </Link>
                )}
              </li>
              <li className="border-right-item">
                <Link
                  to="/about"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  About us
                </Link>
              </li>
              <li className="border-right-item">
                <Link
                  to="/shipping"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Free Delivery
                </Link>
              </li>
              <li className="border-right-item">
                <Link
                  to="/returns"
                  className="text-white text-sm hover-text-decoration-underline"
                >
                  Returns Policy
                </Link>
              </li>
            </ul>
            <ul className="header-top__right flex-align flex-wrap">
              <li className="on-hover-item border-right-item border-right-item-sm-space has-submenu arrow-white">
                <Link to="#" className="text-white text-sm py-8">
                  Help Center
                </Link>
                <ul className="on-hover-dropdown common-dropdown common-dropdown--sm max-h-200 scroll-sm px-0 py-8">
                  <li className="nav-submenu__item">
                    <Link
                      to="#"
                      className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                    >
                      <span className="text-sm d-flex">
                        <i className="ph ph-headset" />
                      </span>
                      Call Center
                    </Link>
                  </li>
                  <li className="nav-submenu__item">
                    <Link
                      to="#"
                      className="nav-submenu__link hover-bg-gray-100 text-gray-500 text-xs py-6 px-16 flex-align gap-8 rounded-0"
                    >
                      <span className="text-sm d-flex">
                        <i className="ph ph-chat-circle-dots" />
                      </span>
                      Live Chat
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* ======================= Middle Top End ========================= */}

      {/* ======================= Middle Header Start ========================= */}
      <header className="header-middle bg-color-one border-bottom border-gray-100">
        <div className="container container-lg">
          <nav className="header-inner flex-between">
            {/* Logo Start */}
            <div className="logo">
              <Link to="/" className="link">
                <img src="assets/images/logo/logo.svg" alt="Paudhawala" />
              </Link>
            </div>
            {/* Logo End  */}

            {/* form location Start */}
            <form
              action="#"
              className="flex-align flex-wrap form-location-wrapper"
            >
              <div className="search-category d-flex h-48 select-border-end-0 radius-end-0 search-form d-sm-flex d-none">
                <select
                  defaultValue={1}
                  className="js-example-basic-single border border-gray-200 border-end-0"
                  name="state"
                >
                  <option value={1}>All Categories</option>
                  <option value={2}>Indoor Plants</option>
                  <option value={3}>Outdoor Plants</option>
                  <option value={4}>Flowering Plants</option>
                  <option value={5}>Air Purifying Plants</option>
                  <option value={6}>Succulents</option>
                  <option value={7}>Fruit Plants</option>
                  <option value={8}>Herbal & Medicinal</option>
                  <option value={9}>Pots & Planters</option>
                  <option value={10}>Seeds & Bulbs</option>
                  <option value={11}>Gardening Tools</option>
                </select>
                <div className="search-form__wrapper position-relative">
                  <input
                    type="text"
                    className="search-form__input common-input py-13 ps-16 pe-18 rounded-end-pill pe-44"
                    placeholder="Search for plants, seeds, pots..."
                  />
                  <button
                    type="submit"
                    className="w-32 h-32 bg-main-600 rounded-circle flex-center text-xl text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
                  >
                    <i className="ph ph-magnifying-glass" />
                  </button>
                </div>
              </div>
              <div className="location-box bg-white flex-align gap-8 py-6 px-16 rounded-pill border border-gray-100">
                <span className="text-gray-900 text-xl d-xs-flex d-none">
                  <i className="ph ph-map-pin" />
                </span>
                <div className="line-height-1">
                  <span className="text-gray-600 text-xs">Delivery to</span>
                  <div className="line-height-1">
                    <select
                      defaultValue={1}
                      className="js-example-basic-simple border-0 bg-transparent"
                      name="state"
                    >
                      <option value={1}>Hajipur, Bihar</option>
                      <option value={2}>Patna, Bihar</option>
                      <option value={3}>Muzaffarpur, Bihar</option>
                      <option value={4}>Delhi, NCR</option>
                      <option value={5}>Mumbai, Maharashtra</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
            {/* form location start */}

            {/* Profile option between location and wishlist */}
            <div
              className="flex-align gap-12"
              style={{
                opacity: isTransitioning ? 0 : 1,
                transition: "opacity 0.3s ease",
              }}
            >
              <UserDropdown />

              {/* Header Middle Right start */}
              <div className="header-right flex-align d-lg-block d-none">
                <div className="flex-align flex-wrap gap-12">
                  <button
                    type="button"
                    className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                  >
                    <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                      <i className="ph ph-magnifying-glass" />
                    </span>
                  </button>
                  <Link
                    to="/wishlist"
                    className="flex-align gap-4 item-hover position-relative"
                  >
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-heart" />
                      {wishlistCount > 0 && (
                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                          {wishlistCount}
                        </span>
                      )}
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Wishlist
                    </span>
                  </Link>
                  <Link
                    to="/cart"
                    className="flex-align gap-4 item-hover position-relative"
                  >
                    <span className="text-2xl text-gray-700 d-flex position-relative me-6 mt-6 item-hover__text">
                      <i className="ph ph-shopping-cart-simple" />
                      {cartCount > 0 && (
                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                          {cartCount}
                        </span>
                      )}
                    </span>
                    <span className="text-md text-gray-500 item-hover__text d-none d-lg-flex">
                      Cart
                    </span>
                  </Link>
                </div>
              </div>
            </div>
            {/* Header Middle Right End  */}
          </nav>
        </div>
      </header>
      {/* ======================= Middle Header End ========================= */}

      {/* ==================== Header Start Here ==================== */}
      <header
        className={`header bg-white border-bottom border-gray-100 ${
          scroll && "fixed-header"
        }`}
      >
        <div className="container container-lg">
          <nav className="header-inner d-flex justify-content-between gap-8">
            <div className="flex-align menu-category-wrapper">
              {/* Category Dropdown Start */}
              <div className="category on-hover-item">
                <button
                  onClick={handleCategoryToggle}
                  type="button"
                  className="category__button flex-align gap-8 fw-medium p-16 border-end border-start border-gray-100 text-heading"
                >
                  <span className="icon text-2xl d-xs-flex d-none">
                    <i className="ph ph-dots-nine" />
                  </span>
                  <span className="d-sm-flex d-none">All</span> Categories
                  <span className="arrow-icon text-xl d-flex">
                    <i className="ph ph-caret-down" />
                  </span>
                </button>
                <div
                  className={`responsive-dropdown cat on-hover-dropdown common-dropdown nav-submenu p-0 submenus-submenu-wrapper ${
                    activeCategory && "active"
                  }`}
                >
                  <button
                    onClick={() => {
                      handleCategoryToggle();
                      setActiveIndexCat(null);
                    }}
                    type="button"
                    className="close-responsive-dropdown rounded-circle text-xl position-absolute inset-inline-end-0 inset-block-start-0 mt-4 me-8 d-lg-none d-flex"
                  >
                    {" "}
                    <i className="ph ph-x" />{" "}
                  </button>
                  {/* Logo Start */}
                  <div className="logo px-16 d-lg-none d-block">
                    <Link to="/" className="link">
                      <img src="assets/images/logo/logo.png" alt="Paudhawala" />
                    </Link>
                  </div>
                  {/* Logo End */}
                  <ul className="scroll-sm p-0 py-8 w-300 max-h-400 overflow-y-auto">
                    {/* Indoor Plants Category */}
                    <li
                      onClick={() => handleCatClick(0)}
                      className={`has-submenus-submenu ${
                        activeIndexCat === 0 ? "active" : ""
                      }`}
                    >
                      <Link
                        onClick={() => setActiveIndexCat(null)}
                        to="/shop?category=indoor"
                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                      >
                        <span className="text-xl d-flex">
                          <i className="ph ph-leaf" />
                        </span>
                        <span>Indoor Plants</span>
                        <span className="icon text-md d-flex ms-auto">
                          <i className="ph ph-caret-right" />
                        </span>
                      </Link>
                      <div
                        className={`submenus-submenu py-16 ${
                          activeIndexCat === 0 ? "open" : ""
                        }`}
                      >
                        <h6 className="text-lg px-16 submenus-submenu__title">
                          Indoor Plants
                        </h6>
                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                          <li>
                            <Link to="/shop?category=air-purifying">
                              Air Purifying Plants
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=low-light">
                              Low Light Plants
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=flowering-indoor">
                              Flowering Indoor Plants
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=succulents">
                              Succulents & Cacti
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=ferns">
                              Ferns & Foliage
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=air-plants">
                              Air Plants
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=snake-plants">
                              Snake Plants
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=peace-lily">
                              Peace Lily
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>

                    {/* Outdoor Plants Category */}
                    <li
                      onClick={() => handleCatClick(1)}
                      className={`has-submenus-submenu ${
                        activeIndexCat === 1 ? "active" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                      >
                        <span className="text-xl d-flex">
                          <i className="ph ph-tree" />
                        </span>
                        <span>Outdoor Plants</span>
                        <span className="icon text-md d-flex ms-auto">
                          <i className="ph ph-caret-right" />
                        </span>
                      </Link>
                      <div
                        className={`submenus-submenu py-16 ${
                          activeIndexCat === 1 ? "open" : ""
                        }`}
                      >
                        <h6 className="text-lg px-16 submenus-submenu__title">
                          Outdoor Plants
                        </h6>
                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                          <li>
                            <Link to="/shop?category=flowering-shrubs">
                              Flowering Shrubs
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=fruit-plants">
                              Fruit Plants
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=herbal">
                              Herbal & Medicinal Plants
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=ornamental-trees">
                              Ornamental Trees
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=palms">
                              Palms & Cycads
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=climbers">
                              Climbers & Creepers
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=hedge-plants">
                              Hedge Plants
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>

                    {/* Flowering Plants Category */}
                    <li
                      onClick={() => handleCatClick(2)}
                      className={`has-submenus-submenu ${
                        activeIndexCat === 2 ? "active" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                      >
                        <span className="text-xl d-flex">
                          <i className="ph ph-flower" />
                        </span>
                        <span>Flowering Plants</span>
                        <span className="icon text-md d-flex ms-auto">
                          <i className="ph ph-caret-right" />
                        </span>
                      </Link>
                      <div
                        className={`submenus-submenu py-16 ${
                          activeIndexCat === 2 ? "open" : ""
                        }`}
                      >
                        <h6 className="text-lg px-16 submenus-submenu__title">
                          Flowering Plants
                        </h6>
                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                          <li>
                            <Link to="/shop?category=roses">Roses</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=marigold">Marigold</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=jasmine">
                              Jasmine (Mogra)
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=hibiscus">
                              Hibiscus (Gudhal)
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=bougainvillea">
                              Bougainvillea
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=orchids">Orchids</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=anthurium">Anthurium</Link>
                          </li>
                        </ul>
                      </div>
                    </li>

                    {/* Fruit Plants Category */}
                    <li
                      onClick={() => handleCatClick(3)}
                      className={`has-submenus-submenu ${
                        activeIndexCat === 3 ? "active" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                      >
                        <span className="text-xl d-flex">
                          <i className="ph ph-apple-logo" />
                        </span>
                        <span>Fruit Plants</span>
                        <span className="icon text-md d-flex ms-auto">
                          <i className="ph ph-caret-right" />
                        </span>
                      </Link>
                      <div
                        className={`submenus-submenu py-16 ${
                          activeIndexCat === 3 ? "open" : ""
                        }`}
                      >
                        <h6 className="text-lg px-16 submenus-submenu__title">
                          Fruit Plants
                        </h6>
                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                          <li>
                            <Link to="/shop?category=mango">Mango</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=guava">Guava (Amrud)</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=lemon">Lemon (Nimbu)</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=pomegranate">
                              Pomegranate (Anar)
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=banana">
                              Banana (Kela)
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=papaya">Papaya</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=chikoo">
                              Chikoo (Sapota)
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>

                    {/* Gardening Essentials Category */}
                    <li
                      onClick={() => handleCatClick(4)}
                      className={`has-submenus-submenu ${
                        activeIndexCat === 4 ? "active" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                      >
                        <span className="text-xl d-flex">
                          <i className="ph ph-flower-tulip" />
                        </span>
                        <span>Gardening Essentials</span>
                        <span className="icon text-md d-flex ms-auto">
                          <i className="ph ph-caret-right" />
                        </span>
                      </Link>
                      <div
                        className={`submenus-submenu py-16 ${
                          activeIndexCat === 4 ? "open" : ""
                        }`}
                      >
                        <h6 className="text-lg px-16 submenus-submenu__title">
                          Gardening Essentials
                        </h6>
                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                          <li>
                            <Link to="/shop?category=pots">
                              Pots & Planters
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=soil">
                              Soil & Fertilizers
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=seeds">Seeds & Bulbs</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=tools">
                              Gardening Tools
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=pebbles">
                              Pebbles & Mulch
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=watering">
                              Watering Systems
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=plant-stands">
                              Plant Stands
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>

                    {/* Herbal & Medicinal Category */}
                    <li
                      onClick={() => handleCatClick(5)}
                      className={`has-submenus-submenu ${
                        activeIndexCat === 5 ? "active" : ""
                      }`}
                    >
                      <Link
                        to="#"
                        className="text-gray-500 text-15 py-12 px-16 flex-align gap-8 rounded-0"
                      >
                        <span className="text-xl d-flex">
                          <i className="ph ph-first-aid-kit" />
                        </span>
                        <span>Herbal & Medicinal</span>
                        <span className="icon text-md d-flex ms-auto">
                          <i className="ph ph-caret-right" />
                        </span>
                      </Link>
                      <div
                        className={`submenus-submenu py-16 ${
                          activeIndexCat === 5 ? "open" : ""
                        }`}
                      >
                        <h6 className="text-lg px-16 submenus-submenu__title">
                          Herbal & Medicinal
                        </h6>
                        <ul className="submenus-submenu__list max-h-300 overflow-y-auto scroll-sm">
                          <li>
                            <Link to="/shop?category=tulsi">
                              Tulsi (Holy Basil)
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=aloe-vera">Aloe Vera</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=neem">Neem</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=lemongrass">
                              Lemongrass
                            </Link>
                          </li>
                          <li>
                            <Link to="/shop?category=mint">Mint (Pudina)</Link>
                          </li>
                          <li>
                            <Link to="/shop?category=curry">
                              Curry Leaves (Kadi Patta)
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              {/* Category Dropdown End  */}

              {/* Menu Start  */}
              <div className="header-menu d-lg-block d-none">
                <ul className="nav-menu flex-align">
                  <li className="nav-menu__item">
                    <NavLink
                      to="/"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className="nav-menu__item">
                    <NavLink
                      to="/shop"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Shop Plants
                    </NavLink>
                  </li>
                  <li className="nav-menu__item">
                    <NavLink
                      to="/contact"
                      className={(navData) =>
                        navData.isActive
                          ? "nav-menu__link activePage"
                          : "nav-menu__link"
                      }
                    >
                      Contact Us
                    </NavLink>
                  </li>
                </ul>
              </div>
              {/* Menu End  */}
            </div>

            {/* Header Right start */}
            <div className="header-right flex-align">
              <Link
                to="tel:+919955859697"
                className="bg-main-600 text-white p-12 h-100 hover-bg-main-800 flex-align gap-8 text-lg d-lg-flex d-none"
              >
                <div className="d-flex text-32">
                  <i className="ph ph-phone-call" />
                </div>
                +91 99558 59697
              </Link>

              {/* Mobile view - Icons only */}
              <div className="me-16 d-lg-none d-block">
                <div className="flex-align flex-wrap gap-12">
                  <button
                    onClick={handleSearchToggle}
                    type="button"
                    className="search-icon flex-align d-lg-none d-flex gap-4 item-hover"
                  >
                    <span className="text-2xl text-gray-700 d-flex position-relative item-hover__text">
                      <i className="ph ph-magnifying-glass" />
                    </span>
                  </button>
                  <div className="position-relative" style={{ zIndex: 9997 }}>
                    <UserDropdown />
                  </div>
                  <Link
                    to="/wishlist"
                    className="flex-align gap-4 item-hover position-relative"
                  >
                    <span className="text-2xl text-gray-700 d-flex me-6 mt-6 item-hover__text">
                      <i className="ph ph-heart" />
                      {wishlistCount > 0 && (
                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                          {wishlistCount}
                        </span>
                      )}
                    </span>
                  </Link>
                  <Link
                    to="/cart"
                    className="flex-align gap-4 item-hover position-relative"
                  >
                    <span className="text-2xl text-gray-700 d-flex me-6 mt-6 item-hover__text">
                      <i className="ph ph-shopping-cart-simple" />
                      {cartCount > 0 && (
                        <span className="w-16 h-16 flex-center rounded-circle bg-main-600 text-white text-xs position-absolute top-n6 end-n4">
                          {cartCount}
                        </span>
                      )}
                    </span>
                  </Link>
                </div>
              </div>

              <button
                onClick={handleMenuToggle}
                type="button"
                className="toggle-mobileMenu d-lg-none ms-3n text-gray-800 text-4xl d-flex"
              >
                <i className="ph ph-list" />
              </button>
            </div>
            {/* Header Right End  */}
          </nav>
        </div>
      </header>
      {/* ==================== Header End Here ==================== */}
    </>
  );
};

export default HeaderOne;
